import React  from 'react'
import DropDown from '../dropdown';
import { GetMarketSegments } from '../../../api/services/pms';

const MarketSegmentsDropDown = ({...props}) => {
    return <DropDown search={false} api={GetMarketSegments} textField="Name" valueField="Id"  {...props}/>
}

export default MarketSegmentsDropDown